
import {object, string, bool} from 'yup'
import Typography from '@library/components/Atoms/Typography/Typography.vue'
import Links from '@library/components/Atoms/Link/Links.vue'
import FormGroup from '@library/components/Atoms/Forms/FormGroup.vue'
import ResetPasswordForm from '@library/components/Molecules/Discovery/ResetPasswordForm.vue'
import ResetPasswordOk from '@library/components/Molecules/Discovery/ResetPasswordOk.vue'
import Button from '@library/components/Atoms/Buttons/Button.vue'

export default {
  name: 'LoginForm',
  components: {
    Typography,
    Links,
    FormGroup,
    ResetPasswordForm,
    ResetPasswordOk,
    Button
  },
  props: {
    labels: Object,
    data: Object,
    dataResetPassword: Object,
    resetPasswordFieldsErrors: {
      type: Object,
      default: () => {}
    },
    version: {
      type: String,
      default: ''
    },
    errorLogin: {
      type: String,
      default: ''
    },
    fieldsErrors: {
      type: Object,
      default: () => ({
        required: '',
        email: ''
      })
    },
    errorReset: {
      type: Boolean,
      default: false
    },
    resetPasswordSubmmited: {
      type: Boolean,
      default: false
    },
    globals: {
      type: Object,
      default: () => {}
    },
    publicPath: {
      type: String,
      default: '/'
    },
    titleTag: {
      type: String,
      default: 'h3'
    },
    isBP: {
      type: String,
      default: ''
    },
    disableAutocomplete: {
      type: Boolean,
      default: true
    },
    isLoginModalOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isErrorLogin() {
      return this.errorLogin != '' && this.errorLogin != 'reset'
    },
    isLoadingAndDisabled() {
      if (this.isErrorLogin) return false
      return this.loadingBtn
    },
    classTitle() {
      return this.version === 'eventtool' ? 'title is-tooBig' : 'title is-big'
    }
  },
  data() {
    return {
      inputs: {
        values: {
          email: null,
          password: null,
          errorLogin: false
        },
        errors: {
          email: '',
          password: '',
          errorLogin: ''
        },
        events: {
          email: ['blur'], // ['blur', 'change', 'input', 'all']
          password: ['blur']
        }
      },
      schema: null,
      open: false,
      loadingBtn: false,
      isChecked: false
    }
  },
  watch: {
    errorLogin(newVal) {
      if (newVal === 'reset') {
        this.loadingBtn = false
      } else if (newVal != '') {
        this.loadingBtn = false
      } else {
        this.loadingBtn = true
      }
    }
  },
  mounted() {
    this.initSchema()
  },
  methods: {
    openResetPasswordModal() {
      this.open = true
      this.$emit('trackForgotPassword')
      this.$emit('closeModalResetPassOk', false)
    },
    initSchema() {
      const {fieldsErrors} = this
      const {required} = fieldsErrors
      this.schema = object().shape({
        email: string().required(required),
        password: string().required(required)
      })
    },
    isValidEmail(email) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return regex.test(email)
    },
    onSubmit() {
      this.schema
        .validate(this.inputs.values, {abortEarly: false})
        .then(e => {
          this.loadingBtn = true
          this.$emit('submit', {
            email: this.inputs.values.email,
            password: this.inputs.values.password,
            rememberMe: this.isChecked
          })
        })
        .catch(err => {
          err.inner.forEach(error => {
            this.inputs.errors = {...this.inputs.errors, [error.path]: error.message}
          })
        })
    },
    validate(event) {
      const filedsValues = this.inputs.values
      const field = event.target.name
      const type = event.type
      const events = this.inputs.events && this.inputs.events[field] ? JSON.parse(JSON.stringify(this.inputs.events[field])) || null : null
      if (!events || events.includes(type) || events.includes('all')) {
        this.schema
          .validateAt(field, filedsValues)
          .then(() => {
            this.inputs.errors[field] = ''
          })
          .catch(err => {
            this.inputs.errors[err.path] = err.message
          })
      }
    },
    closeModalResetInfo($event) {
      this.open = false
      this.$emit('closeModalResetInfo', $event)
    }
  },
  watch: {
    isLoginModalOpen(value) {
      if (!value) {
        this.inputs.errors.email = ''
        this.inputs.errors.password = ''
        this.inputs.values.email = null
        this.inputs.values.password = null
        this.inputs.errors.errorLogin = ''
        this.loadingBtn = false
        this.$refs.loginModal.resetField()
        this.$refs.loginModalEmail.resetField()
      }
    }
  }
}
